import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

const fmt = (v) =>
  "₹" + Number(v).toLocaleString("en-IN", { maximumFractionDigits: 0 });
const BAR_COLORS = ["var(--green)", "var(--blue)", "var(--amber)", "var(--purple)"];

export function PaymodeChart({ data }) {
  if (!data || data.length === 0) return null;

  return (
    <div className="card">
      <div className="card-title">Revenue by payment mode</div>

      {/* Legend */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          marginBottom: "16px",
        }}
      >
        {data.map((m, i) => (
          <span
            key={m.paymode}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "12px",
              color: "var(--muted)",
            }}
          >
            <span
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "2px",
                background: BAR_COLORS[i % BAR_COLORS.length],
                flexShrink: 0,
              }}
            />
            {m.paymode} — {m.percentage}%
          </span>
        ))}
      </div>

      {/* ✅ Bar chart instead of pie */}
      <ResponsiveContainer width="100%" height={220}>
        <BarChart
          data={data}
          margin={{ top: 5, right: 20, left: 10, bottom: 5 }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="var(--grid)"
            vertical={false}
          />
          <XAxis
            dataKey="paymode"
            tick={{ fontSize: 11 }}
            tickFormatter={(v) => (v === "Online Payment" ? "Online" : v)}
          />
          <YAxis
            tickFormatter={(v) => "₹" + (v / 100000).toFixed(1) + "L"}
            tick={{ fontSize: 10 }}
            width={55}
          />
          <Tooltip
            formatter={(v, name) => [fmt(v), "Revenue"]}
            labelFormatter={(l) => l}
          />
          <Bar dataKey="revenue" radius={[6, 6, 0, 0]} maxBarSize={60}>
            {data.map((_, i) => (
              <Cell key={i} fill={BAR_COLORS[i % BAR_COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      {/* Revenue + bill count below each bar */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${data.length}, 1fr)`,
          gap: "8px",
          marginTop: "12px",
          borderTop: "1px solid var(--border)",
          paddingTop: "12px",
        }}
      >
        {data.map((m, i) => (
          <div key={m.paymode} style={{ textAlign: "center" }}>
            <div
              style={{
                fontSize: "13px",
                fontWeight: 700,
                color: BAR_COLORS[i % BAR_COLORS.length],
              }}
            >
              {fmt(m.revenue)}
            </div>
            <div
              style={{
                fontSize: "11px",
                color: "var(--muted)",
                marginTop: "2px",
              }}
            >
              {m.bill_count} bills
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function PartyTypeChart({ data }) {
  if (!data || data.length === 0) return null;
  return (
    <div className="card">
      <div className="card-title">Revenue by party type</div>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart
          data={data}
          layout="vertical"
          margin={{ left: 10, right: 20, top: 10, bottom: 10 }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="var(--grid)"
            horizontal={false}
          />
          <XAxis
            type="number"
            tickFormatter={(v) => "₹" + (v / 100000).toFixed(1) + "L"}
            tick={{ fontSize: 10 }}
          />
          <YAxis
            type="category"
            dataKey="party_type"
            tick={{ fontSize: 12 }}
            width={85}
          />
          <Tooltip formatter={(v) => fmt(v)} />
          <Bar dataKey="revenue" fill="var(--purple)" radius={[0, 6, 6, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}